function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React, { useMemo } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { columnParamType } from './PropTypes/common-proptypes';
import { getColumnClasses } from './utilities/column';
import useConvertProps from './utilities/hooks/useConvertProps';
const Column = props => {
  const {
    children,
    as = 'div',
    offset,
    span,
    start,
    end
  } = props;
  const {
    gridStyles,
    reactProps
  } = useConvertProps({
    gridArea: props.gridArea,
    style: props.style,
    className: props.className,
    hidden: props.hidden
  });
  const {
    style,
    className,
    ...otherReactProps
  } = reactProps;
  const gridColumnClasses = useMemo(() => getColumnClasses(span, start, end, offset), [span, start, end, offset]);
  const columnClasses = classNames(gridColumnClasses, {
    [className]: !!className
  });
  const ColumnTag = as || 'div';
  return /*#__PURE__*/React.createElement(ColumnTag, _extends({
    style: {
      ...gridStyles,
      ...style
    },
    className: columnClasses
  }, otherReactProps), children);
};
Column.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  gridArea: PropTypes.string,
  as: PropTypes.string,
  children: PropTypes.node,
  offset: columnParamType,
  span: columnParamType,
  start: columnParamType,
  end: columnParamType,
  hidden: PropTypes.oneOfType([PropTypes.bool, PropTypes.shape({
    S: PropTypes.bool,
    M: PropTypes.bool,
    L: PropTypes.bool
  })])
};
export default Column;